import React, { Component } from "react";
import Header from '../../components/home/header/header';
import GlobalWarning from '../../components/global-warning/global-warning';
import Footer from '../../components/home/footer/footer';
import ModalSearch from '../../components/modal-search/modal-search';
import ModalMenu from '../../components/modal-menu/modal-menu';
import Scrollup from '../../components/scroll-up/sroll-up';

class Layout5 extends Component {
    render() {
        return (
            <div className="main">
                <Header />
                {/* <GlobalWarning /> */}
                {this.props.children}
                <ModalSearch />
                <ModalMenu />
                <Scrollup />
            </div>
        );
    }
}

export default Layout5;